import cx from "classnames";
import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { IconSplitSave, Paragraph } from "@trainline/depot-web";
import useDisplayOptions from "../../../hooks/useDisplayOptions";
import useJourneyLeg from "../../../hooks/useJourneyLeg";
import useJourneyPlan from "../../../hooks/useJourneyPlan";
import SplitTicketType from "../../../types/SplitTicketType";
import * as s from "./LegHeader.module.css";
const LegHeader = ({ legId }) => {
  const { legNumber, pnrReference, splitSave } = useJourneyLeg(legId);
  const { totalLegs } = useJourneyPlan();
  const { cardStyleLegs } = useDisplayOptions();
  const shouldDisplaySplitSaveIcon = !!splitSave && ((splitSave == null ? void 0 : splitSave.type) === SplitTicketType.DIRECT_SPLIT || (splitSave == null ? void 0 : splitSave.type) === SplitTicketType.INTERCHANGE_SPLIT);
  return /* @__PURE__ */ React.createElement("div", {
    className: cx(s.legHeader, {
      [s.cardHeader]: cardStyleLegs
    })
  }, !!legNumber && /* @__PURE__ */ React.createElement(Paragraph, {
    typeStyle: "body"
  }, /* @__PURE__ */ React.createElement(FormattedHTMLMessage, {
    id: "transitLeg.legNumberInformation",
    values: { displayTotalLegs: !!totalLegs, legNumber, totalLegs }
  })), !!pnrReference && /* @__PURE__ */ React.createElement(Paragraph, {
    typeStyle: "body"
  }, /* @__PURE__ */ React.createElement("span", {
    className: s.legHeaderContentLabel
  }, "PNR:"), " ", pnrReference), shouldDisplaySplitSaveIcon && /* @__PURE__ */ React.createElement("div", {
    className: s.splitSave
  }, /* @__PURE__ */ React.createElement(IconSplitSave, null), /* @__PURE__ */ React.createElement("p", null, "SplitSave")));
};
var LegHeader_default = LegHeader;
export {
  LegHeader_default as default
};
